export const tabViewData = {
    contactTabView: {
        view: 'contactCard',
        width: '1024px',
        tabConditions: {
            contactPersons: { field: 'companyTypeId', operator: 'equals', value: 'company' }
        },
        tabs: [
            {
                id: 'contactPeopleTab',
                key: 'contactPersons',
                label: 'contact.tab.people',
                content: 'ListView',
                view: 'contactPersonList',
                options: { viewFilters: false },
                icon: 'people',
                disabled: false,
            },
            {
                id: 'interactionTab',
                key: 'interactions',
                label: 'contact.tab.interactions',
                content: 'ListView',
                view: 'interactionList',
                options: { viewFilters: false },
                icon: 'interaction',
                disabled: false,
            },
            {
                id: 'invoiceTab',
                key: 'invoices',
                label: 'contact.tab.invoices',
                content: 'ListView',
                view: 'contactInvoiceList',
                options: { viewFilters: false },
                icon: 'invoice',
                disabled: false,
            }
        ]
    },
    locationTabView: {
        view: 'locationCard',
        width: '1024px',
        dynamic: true,
        tabs: [
            {
                id: 'locationItemsTab',
                key: 'locationItems',
                label: 'inventory.location.tabs.products',
                content: 'SubList',
                icon: 'boxes',
                disabled: false,
                view: 'locationItemSubList'
            },
            {
                id: 'locationReservationTab',
                key: 'locationReservations',
                label: 'inventory.location.tabs.reservations',
                content: 'SubList',
                icon: 'lock',
                disabled: false,
                view: 'locationReservationSubList'
            }
        ]
    },
    paymentAccountTabView: {
        view: 'paymentAccountCard',
        width: '1024px',
        tabs: [
            {
                id: 'paymentTransactionTab',
                key: 'paymentTransaction',
                label: 'bank.account.form.tab.transactions',
                content: 'ListView',
                view: 'paymentTransactionList',
                options: { viewFilters: false },
                icon: 'transaction',
                disabled: false,
            }
        ]
    },
    priceListTabView: {
        view: 'priceListCard',
        width: '1024px',
        tabConditions: {
            productGroups: { field: 'scopeId', operator: 'equals', value: 'productGroup' },
            products: { field: 'scopeId', operator: 'equals', value: 'product' }
        },
        tabs: [
            {
                id: 'priceListItemsTab',
                key: 'priceListItems',
                label: 'priceList.tab.items',
                content: 'ListView',
                view: 'priceListItemList',
                options: { viewFilters: false },
                icon: 'boxes',
                disabled: false,
            },
            {
                id: 'productGroupsTab',
                key: 'productGroups',
                label: 'priceList.tab.productGroups',
                content: 'GridList',
                view: 'priceListProductGroupGrid',
                options: {},
                icon: 'peopleGroup',
                disabled: false,
            },
            {
                id: 'productsTab',
                key: 'products',
                label: 'priceList.tab.products',
                content: 'GridList',
                view: 'priceListProductGrid',
                options: {},
                icon: 'boxes',
                disabled: false,
            },
        ]
    },
    productFamilyTabView: {
        view: 'productFamilyCard',
        width: '1024px',
        tabs: [
            {
                id: 'productFamilyProductsTab',
                key: 'products',
                label: 'productFamily.tab.products',
                content: 'GridList',
                view: 'productFamilyVariantGrid',
                options: { viewFilters: false },
                icon: 'boxes',
                disabled: false,
            }
        ]
    },
    productTabView: {
        view: 'productCard',
        width: '1024px',
        tabConditions: {
            bomVersions: { field: 'isBom', operator: 'equals', value: true },
            routingVersions: { field: 'isBom', operator: 'equals', value: true },
            supplierItems: { field: 'type', operator: 'equals', value: 'purchased' }
        },
        tabs: [
            {
                id: 'itemLocationsTab',
                key: 'itemLocations',
                label: 'product.tab.locations',
                content: 'ListView',
                view: 'itemLocationList',
                options: { viewFilters: false },
                icon: 'hall',
                disabled: false,
            },
            {
                id: 'itemPricesTab',
                key: 'itemPrices',
                label: 'product.tab.prices',
                content: 'ListView',
                view: 'productPriceListItemList',
                options: { viewFilters: false },
                icon: 'price',
                disabled: false,
            },
            {
                id: 'bomVersionsTab',
                key: 'bomVersions',
                label: 'product.tab.bom',
                content: 'ListView',
                view: 'bomVersionList',
                options: { viewFilters: false },
                icon: 'factory',
                disabled: false,
            },
            {
                id: 'routingVersionsTab',
                key: 'routingVersions',
                label: 'product.tab.routing',
                content: 'ListView',
                view: 'productRoutingVersionList',
                options: { viewFilters: false },
                icon: 'factory',
                disabled: false,
            },
            {
                id: 'supplierItemsTab',
                key: 'supplierItems',
                label: 'product.tab.suppliers',
                content: 'ListView',
                view: 'supplierItemList',
                options: { viewFilters: false },
                icon: 'contacts',
                disabled: false,
            }
        ]
    },
    projectTabView: {
        view: 'projectCard',
        width: '1024px',
        tabs: [
            {
                id: 'projectTasksTab',
                key: 'tasks',
                label: 'project.tab.tasks',
                content: 'ListView',
                view: 'projectTaskList',
                options: { viewFilters: true },
                icon: 'checkMark',
                disabled: false,
            }
        ]
    },
    serviceTicketTabView: {
        entity: 'serviceTicket',
        view: 'serviceTicketCard',
        titleBar: { mergeParams: ['number'] },
        tabs: [
            {
                id: 'workOrdersTab',
                key: 'workOrders',
                label: 'service.ticket.tab.workOrders',
                content: 'ListView',
                view: 'serviceWorkOrderForTicketList',
                icon: 'task',
                disabled: false
            }
        ]
    },
    serviceWorkOrderTabView: {
        entity: 'serviceWorkOrder',
        view: 'serviceWorkOrderCard',
        titleBar: { mergeParams: ['number'] },
        tabs: [
            {
                id: 'timeEntriesTab',
                key: 'timeEntries',
                label: 'service.workOrder.tab.timeEntries',
                content: 'ListView',
                view: 'timeEntryList',
                icon: 'planner',
                disabled: false
            },
            {
                id: 'partsLinesTab',
                key: 'partsLines',
                label: 'service.workOrder.tab.partsLines',
                content: 'ListView',
                view: 'servicePartsLineList',
                icon: 'boxes',
                disabled: false
            }
        ]
    },
    warehouseTabView: {
        view: 'warehouseCard',
        width: '1024px',
        tabConditions: {
            halls: { field: 'useHalls', operator: 'equals', value: true }
        },
        tabs: [
            {
                id: 'hallsTab',
                key: 'halls',
                label: 'warehouse.tab.halls',
                content: 'ListView',
                view: 'hallList',
                options: { viewFilters: false },
                icon: 'hall',
                disabled: false,
            }
        ]
    },
    workCenterTabView: {
        view: 'workCenterCard',
        width: '1024px',
        tabs: [
            // Positions tab removed in 28.06 Phase C (final cleanup): a work center's
            // positions live on its mapped rack now (edited via the rack card), not on
            // workCenter.locations[]. The card's "Footprint Rack" picker is the link.
            {
                id: 'machinesTab',
                key: 'machines',
                label: 'manufacturing.workCenter.tab.machines',
                content: 'ListView',
                view: 'workCenterMachineList',
                options: { viewFilters: false },
                icon: 'factory',
                disabled: false
            },
            {
                id: 'workersTab',
                key: 'workers',
                label: 'manufacturing.workCenter.tab.workers',
                content: 'CardViewLines',
                icon: 'people',
                section: {
                    id: 'workCenter.workers',
                    meta: {
                        type: 'lines',
                        linesArray: 'workers',
                        linesAddAction: 'manufacturing.workCenter.form.workers.add',
                        width: '100%'
                    },
                    groups: [
                        {
                            type: 'connect',
                            id: 'employeeId',
                            displayField: 'employeeName',
                            label: 'manufacturing.workCenter.form.workers.employee',
                            placeholder: 'manufacturing.workCenter.form.workers.employee.placeholder',
                            modalTitle: 'manufacturing.workCenter.form.workers.employee.modal.title',
                            entity: 'employee',
                            entityParams: { app: 'manufacturing' },
                            valueMap: {
                                'employeeId': 'id',
                                'employeeName': 'name',
                                'employeeCode': 'code',
                                'employeeTitle': 'title'
                            },
                            options: { withHeaders: true },
                            required: true
                        }
                    ],
                    buttons: [
                        { type: 'button', id: 'workCenterTabView.workersTab.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                        { type: 'button', id: 'workCenterTabView.workersTab.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                    ],
                    displaySection: {
                        type: 'lines',
                        emptyField: 'employeeName',
                        emptyMessage: 'manufacturing.workCenter.form.workers.empty',
                        editButtonRightOffset: '40%',
                        columns: [
                            { weight: 3, basis: '60%', elements: [{ type: 'field', value: 'employeeName', scale: 'title' }, { type: 'field', value: 'employeeCode', scale: 'normal' }] },
                            { weight: 2, basis: '40%', elements: [{ type: 'field', value: 'employeeTitle', scale: 'normal' }] }
                        ]
                    }
                }
            }
        ]
    },
    workOperationExecutionTabView: {
        entity: 'workOperation',
        view: 'workOperationExecutionCard',
        titleBar: { mergeParams: ['name'] },
        desktopPanel: { content: 'DocumentDisplay', dataKey: 'documents' },
        tabs: [
            {
                id: 'instructionsTab',
                key: 'instructions',
                label: 'workExecution.tab.instructions',
                content: 'DocumentDisplay',
                targets: ['mobile', 'tablet'],
                icon: 'document',
                disabled: false
            },
            {
                id: 'materialTab',
                key: 'materials',
                label: 'workExecution.tab.materials',
                content: 'GridList',
                view: 'workOperationMaterialGrid',
                icon: 'inventory',
                disabled: false
            },
            {
                id: 'outputTab',
                key: 'outputs',
                label: 'workExecution.tab.outputs',
                content: 'CardEmbed',
                view: 'workOperationOutputCard',
                icon: 'checkMark',
                disabled: false
            },
            {
                id: 'runsTab',
                key: 'runs',
                label: 'workExecution.tab.runs',
                content: 'GridList',
                view: 'workOperationRunsGrid',
                icon: 'play',
                disabled: false
            }
        ]
    },
    workOrderTabView: {
        entity: 'workOrder',
        view: 'workOrderCard',
        titleBar: { mergeParams: ['number'] },
        tabs: [
            {
                id: 'workOperationsTab',
                key: 'workOperations',
                label: 'workOrder.tab.operations',
                content: 'ListView',
                view: 'workOperationList',
                filter: { field: 'workOrderId', source: 'parent' },
                icon: 'checkMark',
                disabled: false
            }
        ]
    },
}
